import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { PowerBIReport } from "../components";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
});

export const HomePage: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <PowerBIReport />
    </div>
  );
};
